/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AmendOrderStatus {
  APPLIED = 'applied',
  PAYMENT_REQUIRED = 'payment_required',
}
